import Base from 'netxcore@netx/core-app/views/confirmView';

import {faExternalLinkAlt, faPlus} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faExternalLinkAlt,
	faPlus,
});

export default class confirmView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
